  (function () {
    if (customElements.get('pdp-reco-carousel')) return;
    customElements.define('pdp-reco-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.inited) return;
        this.dataset.inited = 'true';
        /* Cards are rendered server-side, so the track is present now — just wire the carousel. */
        this.initCarousel(this.closest('[data-pdp-reco]'));
      }
      initCarousel(wrap) {
        if (!wrap) return;
        var track = this.querySelector('[data-reco-track]');
        if (!track) return;
        var prev = wrap.querySelector('[data-reco-prev]');
        var next = wrap.querySelector('[data-reco-next]');
        var nav = wrap.querySelector('.pdp-reco__nav');
        function step() {
          var card = track.querySelector('.pdp-reco__card');
          if (!card) return 300;
          var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 16;
          return card.getBoundingClientRect().width + gap;
        }
        function update() {
          var overflowing = track.scrollWidth > track.clientWidth + 4;
          track.classList.toggle('pdp-reco__track--fit', !overflowing);
          if (nav) nav.style.display = overflowing ? '' : 'none';
          var max = track.scrollWidth - track.clientWidth - 2;
          if (prev) prev.disabled = track.scrollLeft <= 2;
          if (next) next.disabled = track.scrollLeft >= max;
        }
        if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
        if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
        track.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        update();
      }
    });
  })();
